<p>
  icon-full-screen works!
</p>
